module.exports = {"210702002":"石油街道","210702003":"古城街道","210702004":"敬业街道","210702005":"保安街道","210702009":"士英街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210702.json
// module id = 639
// module chunks = 0